module.exports = "1.0.0\n"